import React from 'react';
import { graphql } from 'gatsby';

import HeroHomeSectionDS from 'design-system/src/components/organisms/HeroHomeSection';
import { getSrc } from '../../utils/media';

export default function HeroHomeSection({
    media,
    mediaMobile,
    glbPath,
    ...props
}: any) {
    return (
        <HeroHomeSectionDS
            {...props}
            media={getSrc(media)}
            mediaMobile={getSrc(mediaMobile)}
            glbPath={getSrc(glbPath)}
        />
    );
}

export const query = graphql`
    fragment DatoCmsHeroHomeSection on DatoCmsHeroHomeSection {
        preTitle
        preTitleTag
        title
        titleTag
        description
        cta {
            ...Button
        }
        ctaSecondary {
            ...Button
        }
        media: image {
            ...SourceMedia
            gatsbyImageData(width: 1250, placeholder: BLURRED)
        }
        mediaMobile: imageMobile {
            ...SourceMedia
            gatsbyImageData(width: 991, placeholder: BLURRED)
        }
        glbPath: file3d {
            ...SourceMedia
        }
        hotspots
    }
`;
